import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const ChangePasswordModal = ({ closeModal, setPassword, setError, setSuccess, navigateToLogin, setPasswordChanged }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setModalError] = useState('');
  const [success, setModalSuccess] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setModalError('New password and confirm password do not match');
      return;
    }

    try {
      const empId = localStorage.getItem('empId');
      const response = await axios.post('https://cleezoclass.com:8443/api/changePassword', {
        empId,
        oldPassword,
        newPassword,
        confirmPassword,
      });

      if (response.data.success) {
        setModalSuccess(true);
        setModalError('');
        setPassword(newPassword);
        setSuccess(response.data.message);
        setPasswordChanged(true);
      } else {
        setModalError(response.data.message);
        setModalSuccess(false);
      }
    } catch (error) {
      setModalError(error.response ? error.response.data.message : 'Failed to change password');
      setModalSuccess(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Change Password</h2>
        {success && (
          <p className="success-message">
            Password Changed Successfully! You can now log in with the new password.
          </p>
        )}
        {error && <p className="modal-error">{error}</p>}
        <form onSubmit={handlePasswordChange}>
          <div className="modal-form-group">
            <label>Old Password:</label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              className="input-field"
            />
          </div>
          <div className="modal-form-group">
            <label>New Password:</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="input-field"
            />
          </div>
          <div className="modal-form-group">
            <label>Confirm New Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="input-field"
            />
          </div>
          <button type="submit" className="modal-button">Change Password</button>
          <button type="button" onClick={closeModal} className="modal-button">Close</button>
        </form>
      </div>
    </div>
  );
};

const LoginPage = () => {
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [employeeIds, setEmployeeIds] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false); // Added state for password visibility
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployeeIds = async () => {
      try {
        const response = await axios.get('https://cleezoclass.com:8443/api/getEmployeeIds');
        if (response.data) {
          setEmployeeIds(response.data);
        }
      } catch (error) {
        console.error('Error fetching employee IDs:', error);
      }
    };

    fetchEmployeeIds();
  }, []);

  const handleEmpIdChange = (e) => {
    const selectedEmpId = e.target.value.toUpperCase(); // Automatically convert to uppercase
    setEmpId(selectedEmpId);
    setError('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
  e.preventDefault();

  console.log("🔐 Login button clicked");
  console.log("Entered empId:", empId);
  console.log("Entered password:", password);

  if (!empId || !password) {
    console.warn("⚠️ Missing empId or password");
    setError('Please enter both Employee ID and Password.');
    return;
  }

  try {
    console.log("📡 Sending login request to backend...");

    const response = await axios.post(
      'https://cleezoclass.com:8443/api/validateEmployee',
      {
        empId: empId,
        password: password,
      }
    );

    console.log("✅ Backend response received:", response);
    console.log("📦 Response data:", response.data);

    if (response.data.success) {
      const { empId, empName, designation } = response.data;

      console.log("🎉 Login success");
      console.log("Employee ID:", empId);
      console.log("Employee Name:", empName);
      console.log("Designation:", designation);

      localStorage.setItem('empId', empId);
      localStorage.setItem('empName', empName);
      localStorage.setItem('designation', designation);

      setError('');
      setEmpName(empName);
      setDesignation(designation);

      console.log("➡️ Redirecting based on designation...");

      if (designation === 'HR') {
        navigate('/HRDashboard');
      } else if (designation === 'Marketing Executive') {
        navigate('/SalesPerformance');
      } else if (designation === 'Chief') {
        navigate('/NewPage');
      } else if (designation === 'Project Manager') {
        navigate('/ProjectManagerDashboard');
      } else if (designation === 'Full Stack Developer -trainee') {
        navigate('/Employee_dashboard');
      } else if (designation === 'Marketing Manager') {
        navigate('/Marketing_dashboard');
      } else if (designation === 'Admin') {
        navigate('/Adminfrontend');
      } else {
        console.error("❌ Unknown designation:", designation);
        setError('Designation not found for redirection');
      }
    } else {
      console.warn("❌ Backend says: Invalid credentials");
      setError('Invalid credentials');
    }
  } catch (error) {
    console.error("🚨 Login error occurred");

    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else if (error.request) {
      console.error("No response from server:", error.request);
    } else {
      console.error("Axios error message:", error.message);
    }

    setError('Login failed. Please try again later.');
  }
};


  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const navigateToLogin = () => {
    setPasswordChanged(true);
    setModalOpen(false);
    setSuccessMessage('Password Changed Successfully!');
    navigate('/login');
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="loginpage-container">
      <div className="loginpage-header">
        <div className="loginpage-title">Cleezo class CRM</div>
      </div>

      {isModalOpen ? (
        <ChangePasswordModal
          closeModal={closeModal}
          setPassword={setPassword}
          setError={setError}
          setSuccess={setSuccessMessage}
          navigateToLogin={navigateToLogin}
          setPasswordChanged={setPasswordChanged}
        />
      ) : (
        <div className="loginpage-form">
          <div className="loginpage-heading">
            <h3>Login</h3>
          </div>

          {error && <div className="loginpage-error">{error}</div>}
          {successMessage && <div className="loginpage-success">{successMessage}</div>}

          <div className="loginpage-form-group">
            <label htmlFor="empId">Employee ID</label>
            <input
              type="text"
              id="empId"
              value={empId}
              onChange={handleEmpIdChange}
              placeholder="Enter your Employee ID"
              required
              className="input-field"
            />
          </div>

          {empName && (
            <div className="loginpage-form-group">
              <label htmlFor="empName">Employee Name</label>
              <input type="text" id="empName" value={empName} readOnly className="input-field" />
            </div>
          )}

          {designation && (
            <div className="loginpage-form-group">
              <label htmlFor="designation">Designation</label>
              <input type="text" id="designation" value={designation} readOnly className="input-field" />
            </div>
          )}

          <div className="loginpage-form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-container">
              <input
                type={passwordVisible ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Enter your Password"
                required
                className="input-field"
              />
              <span
                className="eye-icon"
                onClick={togglePasswordVisibility}
              >
                👁️
              </span>
            </div>
          </div>

          <button type="submit" onClick={handleLogin} className="loginpage-button">Login</button>
          {!passwordChanged && (
            <p onClick={openModal} className="loginpage-change-password">Change Password</p>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginPage;